import type { AnyAction } from '@reduxjs/toolkit';
import { dequal } from 'dequal';

import type { CatalogueProductFeature } from 'src/graphql/generated';

const defaultState: CatalogueProductFeature[] | null = null;

const RESET = 'session/productFeatures/RESET';
const UPDATE = 'session/productFeatures/UPDATE';

export const actionResetProductFeatures = () => ({
  type: RESET,
});

export const actionUpdateProductFeatures = (value: any) => ({
  type: UPDATE,
  value,
});

export default (state = defaultState, action: AnyAction) => {
  switch (action.type) {
    case RESET: {
      return defaultState;
    }
    case UPDATE: {
      return dequal(state, action.value) ? state : action.value;
    }
    default: {
      return state;
    }
  }
};

export const forTest = {
  RESET,
  UPDATE,
};
